import React, { useEffect, useState } from 'react'
const OrganizationSelection = () => {
    const [organizzazione, setOrganizzazione] = useState([])
    useEffect(() => {
        setOrganizzazione(JSON.parse(sessionStorage.getItem('organization')))
    }, [])

    if (organizzazione.length > 0) return (
        <p className='text-center'>{organizzazione[0].ragione_sociale}</p>
    )
}

export default OrganizationSelection